module.exports = __webpack_public_path__ + "img/Pulau-Plastik-650x340.a155927c.png";